import Image from "next/image"
import { MinProductItemProps } from "./constants"
import Link from 'next/link';
import { get_original_price, get_sales_price } from "@/lib/Definitions";
import { motion } from "framer-motion";
import { motionVariants } from "../Common/GlobalVars";


interface PwPProductProps {
  product: MinProductItemProps;
  setSelectProduct: (product: MinProductItemProps) => void;
}

const PwPProduct = (props: PwPProductProps) => {
  const { product } = props;

  const show_sales_price = () => {
    const sales_price = get_sales_price(product, null);

    if (Array.isArray(sales_price.price)) {
      return (
        <p className={`flex text-sm font-bold text-price`}>
          {sales_price.price[0].toLocaleString()}{process.env.NEXT_PUBLIC_CURRENCY} ~ {sales_price.price[1].toLocaleString()}{process.env.NEXT_PUBLIC_CURRENCY}
        </p>
      )
    } else {
      return (
        <p className={`flex text-sm font-bold ${sales_price.promotion ? "text-mooimom" : "text-price"}`}>
          {sales_price.price.toLocaleString()}{process.env.NEXT_PUBLIC_CURRENCY}
        </p>
      )
    }
  }

  const show_origin_price = () => {
    const origin_price = get_original_price(product, null);

    if (origin_price === null) {
      return (<></>)
    } else {
      return (
        <p className="text-sm line-through text-originPrice">
          {origin_price.toLocaleString()}{process.env.NEXT_PUBLIC_CURRENCY}
        </p>
      )
    }
  }

  return (
    <motion.div
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: true }}
      variants={motionVariants}
      className="grid grid-cols-3 p-4 border border-solid border-hrBg gap-x-4"
    >
      <Image
        src={product.image}
        alt={product.name + " image"}
        quality={100}
        width={800}
        height={800}
        className="object-contain aspect-square"
      />
      <div className="col-span-2 font-poppins">
        <Link href={`/product/${product.slug}`}>
          <p className="h-10 mt-2 text-sm text-black line-clamp-2 text-ellipsis">{product.name}</p>
          {show_sales_price()}
          {show_origin_price()}
        </Link>
        <div className="flex justify-end mt-4">
          <button
            className="px-4 font-bold text-white bg-mooimom rounded-xl"
            onClick={() => props.setSelectProduct(product)}
          >
            +
          </button>
        </div>
      </div>
    </motion.div>
  )
}

export default PwPProduct
